import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock, Facebook, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Section */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <img 
                src="/PinHighLogo_NoTagline.png"
                alt="Pin High Golf & Lounge"
                className="h-16 w-auto"
              />
            </Link>
            <p className="text-gray-400 text-sm mb-4">
              Indoor golf simulators on the Westside of Cleveland in Bay Village. Play year-round on world-class courses with Foresight technology.
            </p>
            <div className="flex gap-4">
              <a href="https://www.facebook.com/profile.php?id=61578682262757" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-green-400 transition-colors" aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://www.instagram.com/pinhighbay/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-green-400 transition-colors" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-green-400 transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-gray-400 hover:text-green-400 transition-colors text-sm">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/memberships" className="text-gray-400 hover:text-green-400 transition-colors text-sm">
                  Memberships
                </Link>
              </li>
              <li>
                <Link to="/leagues" className="text-gray-400 hover:text-green-400 transition-colors text-sm">
                  Leagues
                </Link>
              </li>
              <li>
                <Link to="/lessons" className="text-gray-400 hover:text-green-400 transition-colors text-sm">
                  Lessons
                </Link>
              </li>
              <li>
                <Link to="/sportsbar" className="text-gray-400 hover:text-green-400 transition-colors text-sm">
                  Sportsbar
                </Link>
              </li>
              <li>
                <Link to="/events" className="text-gray-400 hover:text-green-400 transition-colors text-sm">
                  Private Events
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" />
                <span className="text-gray-400 text-sm">
                  27229 Wolf Road<br />
                  Bay Village, OH 44140
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-green-400 flex-shrink-0" />
                <a href="tel:4404551078" className="text-gray-400 hover:text-green-400 transition-colors text-sm">
                  (440) 455-1078
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-green-400 flex-shrink-0" />
                <a href="mailto:dennis@pinhighbay.com" className="text-gray-400 hover:text-green-400 transition-colors text-sm">
                  dennis@pinhighbay.com
                </a>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h3 className="text-lg font-bold mb-4">Hours of Operation</h3>
            <ul className="space-y-2">
              <li className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" />
                <div className="text-gray-400 text-sm">
                  <p className="font-semibold text-white mb-1">Monday - Friday</p>
                  <p>9:00 AM - 10:00 PM</p>
                </div>
              </li>
              <li className="flex items-start gap-3 ml-8">
                <div className="text-gray-400 text-sm">
                  <p className="font-semibold text-white mb-1">Saturday</p>
                  <p>10:00 AM - 11:00 PM</p>
                </div>
              </li>
              <li className="flex items-start gap-3 ml-8">
                <div className="text-gray-400 text-sm">
                  <p className="font-semibold text-white mb-1">Sunday</p>
                  <p>10:00 AM - 9:00 PM</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Pin High Golf & Lounge. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="/privacy" className="text-gray-400 hover:text-green-400 transition-colors text-sm">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-gray-400 hover:text-green-400 transition-colors text-sm">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;